module.exports = __webpack_public_path__ + "img/form@2x.40944e4.jpg";